import { apiClient } from '@/components/api/apiClient.ts';

export const login = async (
	url: string,
	{ arg }: { arg: { email: string; name: string } },
) => {
	const res = await apiClient.post(url, { adminEmail: arg.email });
	if (res.ok) return { token: res.data as string, name: arg.name };
	else throw res.data;
};
